export default "__VITE_ASSET__CetrT8nw__"